import { render, staticRenderFns } from "./AddFriendsInput.vue?vue&type=template&id=55bb185b&scoped=true"
import script from "./AddFriendsInput.vue?vue&type=script&lang=js"
export * from "./AddFriendsInput.vue?vue&type=script&lang=js"
import style0 from "./AddFriendsInput.vue?vue&type=style&index=0&id=55bb185b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bb185b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bb185b')) {
      api.createRecord('55bb185b', component.options)
    } else {
      api.reload('55bb185b', component.options)
    }
    module.hot.accept("./AddFriendsInput.vue?vue&type=template&id=55bb185b&scoped=true", function () {
      api.rerender('55bb185b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenge-friends/components/AddFriendsInput.vue"
export default component.exports